import {BootstrapData} from './bootstrap-data';
import {createContext, useContext} from 'react';

export interface BoostrapDataContextValue<T = BootstrapData> {
  data: T;
  setBootstrapData: (data: string | T) => void;
  mergeBootstrapData: (data: Partial<T>) => void;
  invalidateBootstrapData: () => void;
}

export const BoostrapDataContext = createContext<BoostrapDataContextValue>(
  null!
);

export function useBootstrapData() {
  const context = useContext(BoostrapDataContext);
  if (!context) {
    // Return a safe fallback when context is not available instead of throwing
    return {
      data: {
        themes: { all: [], selectedThemeId: null },
        sentry_release: '',
        is_mobile_device: false,
        csrf_token: '',
        settings: {} as any,
        user: null,
        guest_role: null,
        i18n: {
          id: 0,
          name: 'English',
          language: 'en',
          lines: {} as Record<string, string>
        },
        default_meta_tags: [],
        show_cookie_notice: false,
      } as BootstrapData,
      setBootstrapData: () => {},
      mergeBootstrapData: () => {},
      invalidateBootstrapData: () => {},
    };
  }
  return context;
}
